import api from "./api";

export const fetchAgentCertifications = async (agentId = null) => {
    try {
        const url = agentId
            ? `agent-certification-assessment/admin/certifications?agent_id=${agentId}`
            : `agent-certification-assessment/admin/certifications`;

        const response = await api.get(url);

        if (response.status === 200 && response.data?.success) {
            return {
                success: true,
                data: response.data.data,
            };
        }

        return {
            success: false,
            error:
                response.data?.message ||
                "Failed to retrieve agent certifications.",
        };
    } catch (error) {
        return {
            success: false,
            error:
                error.response?.data?.message ||
                error.message ||
                "Failed to retrieve agent certifications.",
        };
    }
};